/**
 * Author: Hurman
 * Email: HurmanKz@hotmail.com
 */
import Vue from "vue";

const AwesomeTextarea = Vue.component("editable-textarea", {
  methods: {
    resizeTextarea(e) {
      e.target.style.height = "auto";
      // most important for auto height and scrolling
      e.target.style.height = e.target.scrollHeight + "px";
      e.target.blur();
      e.target.focus();
    }
  },

  mounted() {
    this.$el.addEventListener("input", this.resizeTextarea);
    this.$el.addEventListener("keyup", this.resizeTextarea);
  },

  beforeDestroy() {
    this.$el.removeEventListener("input", this.resizeTextarea);
    this.$el.removeEventListener("keyup", this.resizeTextarea);
  },

  render() {
    return this.$slots.default[0];
  }
});

export default AwesomeTextarea;
